import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserProfileService } from './user-profile.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as myGlobal from '../../../global';

@Component( {
    selector: 'app-user-profile',
    templateUrl: './user-profile.component.html',
    styleUrls: ['./user-profile.component.css']
} )
export class UserProfileComponent implements OnInit {
    maxDate = new Date();
    date_pattern = myGlobal.DATE_PAT;
    selectedMoment;
    selectedname1;
    selectedname2;
    jobtitle;
    cookieValue = '';
    cookieUsername = '';

    changePasswordForm = new FormGroup( {
        currentpassword: new FormControl( '', [Validators.required] ),
        newpassword: new FormControl( '', [Validators.required] )
    } );

    userInfoArr = [];
    userInfo;
    isFormValid = true;

    personClass = {
        'firstName': [
            {'success-validate': false, 'error-validate': false},
            {'icon-work-done': false, 'icon-close-border': false}
        ],
        'lastName': [
            {'success-validate': false, 'error-validate': false},
            {'icon-work-done': false, 'icon-close-border': false}
        ],
        // 'dob': [
        //   { 'success-validate': false, "error-validate": false },
        //   { "icon-work-done": false, 'icon-close-border': false }
        // ],
        // 'companyName': [
        //   { 'success-validate': false, "error-validate": false },
        //   { "icon-work-done": false, 'icon-close-border': false }
        // ],
        // 'jobTitle': [
        //   { 'success-validate': false, "error-validate": false },
        //   { "icon-work-done": false, 'icon-close-border': false }
        // ],
        // 'income': [
        //   { 'success-validate': false, "error-validate": false },
        //   { "icon-work-done": false, 'icon-close-border': false }
        // ]
    };
    isIncomePat;
    isIncomeReq;
    change_pass_msg;
    ischange = false;
    ischangeErr = false;

    updateUserForm = new FormGroup( {
        firstName: new FormControl( '', [Validators.required] ),
        lastName: new FormControl( '', [Validators.required] ),
        dob: new FormControl(),
        email: new FormControl( {value: '', disabled: true}, [Validators.required] ),
        companyName: new FormControl(),
        jobTitle: new FormControl(),
        income: new FormControl(),
        applicant_type: new FormControl( '', [Validators.required] )
    } );

    isupdate = false;
    isShow = false;
    isupdateErr = false;
    fun = 'Edit';
    // onEnterIncome() {
    //   this.isFormValid = true;
    //   if (this.updateUserForm.get("income").value > 0) {
    //     this.isIncomeReq = false;
    //     this.isIncomePat = false
    //     this.personClass['income'] = [
    //       { 'success-validate': true, "error-validate": false },
    //       { "icon-work-done": true, 'icon-close-border': false }
    //     ]

    //   }
    //   else {
    //     this.isFormValid = false;
    //     this.isIncomeReq = true;

    //     this.personClass['income'] = [
    //       { 'success-validate': false, "error-validate": true },
    //       { "icon-work-done": false, 'icon-close-border': true }
    //     ]
    //   }
    // }
    updat_msg;

    constructor( private cookieService: CookieService, private route: ActivatedRoute,
                 private router: Router, private user: UserProfileService ) {
        this.user_profile();
        this.updat_msg = false;
    }

    ngOnInit() {
        this.cookieUsername = this.cookieService.get( 'username' );
    }

    onClickdob() {
        if ( this.updateUserForm.get( 'dob' ).hasError( 'required' ) ) {
            this.isFormValid = false;
            this.personClass[ 'dob' ] = [
                {'success-validate': false, 'error-validate': true},
                {'icon-work-done': false, 'icon-close-border': true}
            ];
        } else {
            this.isFormValid = true;
            this.personClass[ 'dob' ] = [
                {'success-validate': true, 'error-validate': false},
                {'icon-work-done': true, 'icon-close-border': false}
            ];
        }
    }

    onEnterdob() {
        this.updateUserForm.controls[ 'dob' ].setValue( '' );
        this.isFormValid = false;
        this.personClass[ 'dob' ] = [
            {'success-validate': false, 'error-validate': true},
            {'icon-work-done': false, 'icon-close-border': true}
        ];
    }

    onEnterfirstname() {
        if ( this.updateUserForm.get( 'firstName' ).value.trim() !== '' ) {
            this.isFormValid = true;
            this.personClass[ 'firstName' ] = [
                {'success-validate': true, 'error-validate': false},
                {'icon-work-done': true, 'icon-close-border': false}
            ];
        } else {
            this.isFormValid = false;
            this.updateUserForm.get( 'firstName' ).setValue( '' );

            this.personClass[ 'firstName' ] = [
                {'success-validate': false, 'error-validate': true},
                {'icon-work-done': false, 'icon-close-border': true}
            ];
        }
    }

    onEnterlastname() {
        if ( this.updateUserForm.get( 'lastName' ).value.trim() !== '' ) {
            this.isFormValid = true;
            this.personClass[ 'lastName' ] = [
                {'success-validate': true, 'error-validate': false},
                {'icon-work-done': true, 'icon-close-border': false}
            ];
        } else {
            this.isFormValid = false;
            this.updateUserForm.get( 'lastName' ).setValue( '' );
            this.personClass[ 'lastName' ] = [
                {'success-validate': false, 'error-validate': true},
                {'icon-work-done': false, 'icon-close-border': true}
            ];
        }
    }

    onEntercompanyName() {
        if ( this.updateUserForm.get( 'companyName' ).value ) {
            if ( this.updateUserForm.get( 'companyName' ).value.trim() === '' ) {
                this.updateUserForm.get( 'companyName' ).setValue( '' );
            }
        }
    }

    onEnterjobTitle() {
        if ( this.updateUserForm.get( 'jobTitle' ).value ) {
            if ( this.updateUserForm.get( 'jobTitle' ).value.trim() === '' ) {
                this.updateUserForm.get( 'jobTitle' ).setValue( '' );
            }
        }
    }

    user_profile() {
        this.userInfoArr = [];
        this.userInfo = [];
        const user = {
            'userId': this.cookieService.get( 'userId' ),
        };
        const UserId = user.userId;
        this.user.getuserInfo( UserId )
            .subscribe( post => {
                this.userInfoArr = [post];
                this.userInfo = this.userInfoArr;
                this.router.navigate( ['user-profile'] );
            }, error => {
                console.log( ' error.error.error_msg;' );
            } );

    }

    edit_profile( userInfoEdit ) {
        this.updateUserForm.reset();
        this.updateUserForm.get( 'firstName' ).setValue( userInfoEdit[ 0 ].personal_info.first_name );
        this.updateUserForm.get( 'lastName' ).setValue( userInfoEdit[ 0 ].personal_info.last_name );
        this.updateUserForm.get( 'applicant_type' ).setValue( userInfoEdit[ 0 ].property_info.property_type );
        this.updateUserForm.get( 'email' ).setValue( userInfoEdit[ 0 ].personal_info.email_id );

        if ( userInfoEdit[ 0 ].personal_info.date_of_birth ) {
            this.updateUserForm.get( 'dob' ).setValue( userInfoEdit[ 0 ].personal_info.date_of_birth );
        }
        if ( userInfoEdit[ 0 ].company_info ) {
            if ( userInfoEdit[ 0 ].company_info.company_name ) {
                this.updateUserForm.get( 'companyName' ).setValue( userInfoEdit[ 0 ].company_info.company_name );
            }
            if ( userInfoEdit[ 0 ].company_info.job_title ) {
                this.updateUserForm.get( 'jobTitle' ).setValue( userInfoEdit[ 0 ].company_info.job_title );
            }
            if ( userInfoEdit[ 0 ].company_info.income ) {
                this.updateUserForm.get( 'income' ).setValue( userInfoEdit[ 0 ].company_info.income );
            }
        }
    }

    clearChangePasswordForm() {
        this.changePasswordForm.reset();
        this.ischangeErr = false;
        this.ischange = false;
    }

    changePassword() {
        const changepassobj = {
            'username': this.cookieService.get( 'username' ),
            'current_password': this.changePasswordForm.get( 'currentpassword' ).value,
            'new_password': this.changePasswordForm.get( 'newpassword' ).value,
        };
        if ( this.changePasswordForm.valid ) {

            this.user.postChangePassword( changepassobj )
                .subscribe( post => {
                    this.ischangeErr = false;
                    this.ischange = true;
                    this.change_pass_msg = 'success';
                    this.changePasswordForm.reset();
                }, error => {
                    this.ischangeErr = true;
                    this.ischange = false;
                    this.change_pass_msg = error.error.error_msg;
                    this.changePasswordForm.reset();
                } );
        }
    }

    submitData() {
        this.clearIcon();

        this.fun = 'Edit';
        this.isShow = false;
        this.userInfo[ 0 ].property_info.property_type = this.updateUserForm.get( 'applicant_type' ).value.trim();
        this.userInfo[ 0 ].personal_info.last_name = this.updateUserForm.get( 'lastName' ).value.trim();
        this.userInfo[ 0 ].personal_info.first_name = this.updateUserForm.get( 'firstName' ).value.trim();
        this.userInfo[ 0 ].personal_info.date_of_birth = this.updateUserForm.get( 'dob' ).value;

        if ( this.updateUserForm.get( 'dob' ).value ) {
            if ( this.userInfo[ 0 ].personal_info.date_of_birth ) {

                this.userInfo[ 0 ].personal_info.date_of_birth = this.updateUserForm.get( 'dob' ).value;

            } else {
                this.userInfo[ 0 ].personal_info[ 'date_of_birth' ] = this.updateUserForm.get( 'dob' ).value;

            }
        } else {
            if ( this.userInfo[ 0 ].personal_info.date_of_birth ) {
                delete this.userInfo[ 0 ].personal_info.date_of_birth;
            }
        }

        if ( this.updateUserForm.get( 'income' ).value || this.updateUserForm.get( 'companyName' ).value
            || this.updateUserForm.get( 'jobTitle' ).value ) {
            if ( !this.userInfo[ 0 ].company_info ) {
                this.userInfo[ 0 ][ 'company_info' ] = {};
                this.userInfo[ 0 ].company_info[ 'income' ] = this.updateUserForm.get( 'income' ).value;
                this.userInfo[ 0 ].company_info[ 'job_title' ] = this.updateUserForm.get( 'jobTitle' ).value;
                this.userInfo[ 0 ].company_info[ 'company_name' ] = this.updateUserForm.get( 'companyName' ).value;
            } else {
                this.userInfo[ 0 ].company_info[ 'income' ] = this.updateUserForm.get( 'income' ).value;
                this.userInfo[ 0 ].company_info[ 'job_title' ] = this.updateUserForm.get( 'jobTitle' ).value;
                this.userInfo[ 0 ].company_info[ 'company_name' ] = this.updateUserForm.get( 'companyName' ).value;
            }
        } else {
            if ( this.userInfo[ 0 ].company_info ) {
                delete this.userInfo[ 0 ].company_info;
            }

        }

        for ( let key in this.userInfo[ 0 ].company_info ) {
            if ( !this.userInfo[ 0 ].company_info[ key ] ) {
                delete this.userInfo[ 0 ].company_info[ key ];
            }
        }
        for ( let key in this.userInfo[ 0 ].personal_info ) {
            if ( !this.userInfo[ 0 ].personal_info[ key ] ) {
                delete this.userInfo[ 0 ].personal_info[ key ];
            }
        }

        for ( let key in this.userInfo[ 0 ].personal_info ) {
            if ( !this.userInfo[ 0 ].personal_info[ key ] ) {
                delete this.userInfo[ 0 ].personal_info[ key ];
            }
        }

        this.user.postUpdateUser( this.userInfo[ 0 ] )
            .subscribe( post => {
                this.user_profile();

                for ( let i in post ) {
                    this.updat_msg = post[ i ];
                }

                document.getElementById( 'editProfile-popup' ).click();
                this.isupdate = true;

                setTimeout( () => {
                    this.isupdate = false;
                }, 5000 );
                this.isupdateErr = false;

            }, error => {
                this.isupdate = false;
                this.isupdateErr = true;
                this.updat_msg = error.error.error_msg;

            } );
    }

    clearMsg() {
        this.isupdate = false;
        this.isupdateErr = false;
    }

    clearIcon() {
        this.personClass = {
            'firstName': [
                {'success-validate': false, 'error-validate': false},
                {'icon-work-done': false, 'icon-close-border': false}
            ],
            'lastName': [
                {'success-validate': false, 'error-validate': false},
                {'icon-work-done': false, 'icon-close-border': false}
            ],
            // 'dob': [
            //   { 'success-validate': false, "error-validate": false },
            //   { "icon-work-done": false, 'icon-close-border': false }
            // ],
            // 'companyName': [
            //   { 'success-validate': false, "error-validate": false },
            //   { "icon-work-done": false, 'icon-close-border': false }
            // ],
            // 'jobTitle': [
            //   { 'success-validate': false, "error-validate": false },
            //   { "icon-work-done": false, 'icon-close-border': false }
            // ],
            // 'income': [
            //   { 'success-validate': false, "error-validate": false },
            //   { "icon-work-done": false, 'icon-close-border': false }
            // ]
        };
    }
}
